export default {
	setLeague(state, payload) {
		state.leagues = payload;
	},
	setSchedules(state, payload) {
		state.schedules = payload;
	},
	addNewSchedule(state, payload) {
		state.schedules.push(payload);
	},
	setDivisions(state, payload) {
		state.divisions = payload;
	},
	addNewDivision(state, payload) {
		state.divisions.push(payload)
	},
};